export default "__VITE_ASSET__DIwElHSC__"